module.exports = __webpack_public_path__ + "img/identity_4.f2835da2.jpg";